import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

interface FetcherParams {
  clientId: string;
  categoryId: string;
}

export interface GoalsOptionsDTO {
  Title: string;
  Subtitle: string;
  Ideas: string[];
  Inflation: number;
  Accounts: {
    Id: string;
    Name: string;
    Institution: string;
    Balance: number;
  }[];
  YearsOptions: number[];
}

export const fetchGoalsOptions = async ({
  clientId,
  categoryId,
}: FetcherParams): Promise<GoalsOptionsDTO> => {
  return authFetch(
    urlWithParams('/Consumer/PulseCheckGoals/Options', {
      clientId,
      pulseCheckCategoryId: categoryId,
    }),
  );
};

interface QueryParams {
  clientId: string;
  categoryId: string;
}

export const useGoalsOptionsQuery = ({ clientId, categoryId }: QueryParams) => {
  return useQuery(
    queryKeys.goalsOptions(clientId, categoryId),

    () => fetchGoalsOptions({ clientId, categoryId }),

    {
      cacheTime: 0,
    },
  );
};
